export const Loader = ({size = 60, fillColors=["#ffffff", "#ffffff", "#ffffff"], ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <circle cx="4" cy="12" r="3" fill={fillColors[0]}>
        <animate id="svgSpinners3DotsBounce0" attributeName="cy" begin="0;svgSpinners3DotsBounce1.end+0.188s" calcMode="spline" dur="0.45s" keySplines=".33,.66,.66,1;.33,0,.66,.33" values="12;6;12" />
      </circle>
      <circle cx="12" cy="12" r="3" fill={fillColors[1]}>
        <animate attributeName="cy" begin="svgSpinners3DotsBounce0.begin+0.075s" calcMode="spline" dur="0.45s" keySplines=".33,.66,.66,1;.33,0,.66,.33" values="12;6;12" />
      </circle>
      <circle cx="20" cy="12" r="3" fill={fillColors[2]}>
        <animate id="svgSpinners3DotsBounce1" attributeName="cy" begin="svgSpinners3DotsBounce0.begin+0.15s" calcMode="spline" dur="0.45s" keySplines=".33,.66,.66,1;.33,0,.66,.33" values="12;6;12" />
      </circle>
    </svg>
  )
}